<template>
    <div class="algolia-card-wrapper">
        <div class="image-bound-box">
            <img v-if="isLoaded" :src="imageURL"/>
        </div>
        <div>
            <a class="link-no-style" :href='cardDetails.item.fields.url'>
                <h4>{{ cardDetails.item.fields.name }}</h4>
            </a>
            <p class="mb-5">{{ cardDetails.item.fields.description }}</p>
            <p>{{ cardDetails.item.fields.location }}</p>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "AlgoliaResultCard",
    props: {
        card: Object
    },
    data() {
        return {
            isLoaded: false,
            imageURL: "",
            cardDetails: this.card
        };
    },
    methods: {
        getDescription() {
            if(this.cardDetails.item.fields.description)
                this.cardDetails.item.fields.description =  this.cardDetails.item.fields.description[0].content[0].value;
            else
                this.cardDetails.item.fields.description= ""
        },
        async setImageURL(id) {
            try {
                this.isLoaded = false;
                const response = await axios.get('image/' + id);
                this.imageURL = response.data;
                return response.data
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoaded = true;
            }
        }
    },
    created() {
        this.getDescription();
        this.imageURL = this.card.item.fields.image && this.setImageURL(this.card.item.fields.image);
    }
}
</script>

<style scoped>

.link-no-style {
    text-decoration: none;
}

.algolia-card-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.image-bound-box {
    min-width: 30%;
    height: 200px;
    margin-right: 3rem;
    object-fit: fill;
    overflow: hidden;
}

</style>
